import DepositACheckPage from "components/pages/DepositACheckPage";

export default function CaptureMabiDepositsDeposit() {
    return <DepositACheckPage />
}